import { motion } from "motion/react"
import { RightArrow } from "../../components/svgCollection"
import { AUTH_BODY, AUTH_DISPLAY, AUTH_MONO } from "./authTheme"
import { useIsKeyboardOpen } from "../../hooks/useIsKeyboardOpen"

const BODY = AUTH_BODY

type AuthSheetLayoutProps = {
    title: string
    /** Назад на предыдущий шаг (не закрывает модалку) */
    onBack?: () => void
    footer?: React.ReactNode
    children: React.ReactNode
}

export default function AuthSheetLayout({ title, onBack, footer, children }: AuthSheetLayoutProps) {
    const isKeyboardOpen = useIsKeyboardOpen()
    return (
        <div className="flex h-full min-h-0 w-full flex-1 flex-col gap-4 px-5 py-4 md:gap-5 md:px-6 md:py-8">
            <div className="flex shrink-0 items-center gap-3">
                {onBack ? (
                    <motion.button
                        type="button"
                        whileTap={{ scale: 0.9 }}
                        onClick={onBack}
                        className="flex size-9 shrink-0 cursor-pointer items-center justify-center rounded-full border border-white/20 bg-white/[0.06] transition-colors hover:bg-white/[0.12]"
                        aria-label="Назад">
                        <div className="rotate-180">
                            <RightArrow />
                        </div>
                    </motion.button>
                ) : null}
                <h2
                    className="min-w-0 flex-1 self-center text-white leading-tight"
                    style={{
                        fontFamily: AUTH_DISPLAY,
                        fontWeight: 800,
                        fontSize: "clamp(22px, 4vw, 34px)",
                        letterSpacing: "-0.02em",
                    }}>
                    {title}
                </h2>
            </div>

            <div className="flex min-h-0 flex-1 flex-col gap-5 overflow-x-hidden overflow-y-auto overscroll-contain md:gap-6 [-webkit-overflow-scrolling:touch]">
                {children}
            </div>

            {footer ? (
                <div className={`mt-auto flex shrink-0 flex-col gap-3 ${isKeyboardOpen ? "pb-1" : "pb-[max(1.25rem,var(--safe-bottom))]"}`}>
                    {footer}
                </div>
            ) : null}
        </div>
    )
}

type AuthSheetButtonProps = {
    variant?: "primary" | "secondary"
    disabled?: boolean
    onClick?: () => void
    href?: string
    children: React.ReactNode
}

export function AuthSheetButton({ variant = "primary", disabled, onClick, href, children }: AuthSheetButtonProps) {
    const className = `flex h-[50px] w-full cursor-pointer items-center justify-center rounded-[14px] text-[14px] font-semibold sm:text-[15px] ${
        disabled
            ? "cursor-not-allowed bg-white/10 text-white/40"
            : variant === "primary"
              ? "bg-accent text-white shadow-[0_0_24px_rgba(228,32,107,0.35)]"
              : "bg-[#349be6] text-white shadow-[0_0_22px_rgba(52,155,230,0.35)]"
    }`

    const style = { fontFamily: variant === "primary" ? BODY : AUTH_MONO, fontWeight: variant === "primary" ? 600 : 700 } as const

    if (href) {
        return (
            <a href={href} className={className} style={style}>
                {children}
            </a>
        )
    }

    return (
        <button type="button" disabled={disabled} onClick={onClick} className={className} style={style}>
            {children}
        </button>
    )
}
